/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SystemDropdownParameterParam } from './SystemDropdownParameterParam';
import {
    SystemDropdownParameterParamFromJSON,
    SystemDropdownParameterParamFromJSONTyped,
    SystemDropdownParameterParamToJSON,
    SystemDropdownParameterParamToJSONTyped,
} from './SystemDropdownParameterParam';

/**
 * 
 * @export
 * @interface SystemDropdownOptionParam
 */
export interface SystemDropdownOptionParam {
    /**
     * 
     * @type {string}
     * @memberof SystemDropdownOptionParam
     */
    id: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SystemDropdownOptionParam
     */
    isHidden: boolean;
    /**
     * 
     * @type {string}
     * @memberof SystemDropdownOptionParam
     */
    value: string;
    /**
     * 
     * @type {Array<SystemDropdownParameterParam>}
     * @memberof SystemDropdownOptionParam
     */
    parameters: Array<SystemDropdownParameterParam>;
}

/**
 * Check if a given object implements the SystemDropdownOptionParam interface.
 */
export function instanceOfSystemDropdownOptionParam(value: object): value is SystemDropdownOptionParam {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('isHidden' in value) || value['isHidden'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('parameters' in value) || value['parameters'] === undefined) return false;
    return true;
}

export function SystemDropdownOptionParamFromJSON(json: any): SystemDropdownOptionParam {
    return SystemDropdownOptionParamFromJSONTyped(json, false);
}

export function SystemDropdownOptionParamFromJSONTyped(json: any, ignoreDiscriminator: boolean): SystemDropdownOptionParam {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'isHidden': json['isHidden'],
        'value': json['value'],
        'parameters': ((json['parameters'] as Array<any>).map(SystemDropdownParameterParamFromJSON)),
    };
}

export function SystemDropdownOptionParamToJSON(json: any): SystemDropdownOptionParam {
    return SystemDropdownOptionParamToJSONTyped(json, false);
}

export function SystemDropdownOptionParamToJSONTyped(value?: SystemDropdownOptionParam | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'isHidden': value['isHidden'],
        'value': value['value'],
        'parameters': ((value['parameters'] as Array<any>).map(SystemDropdownParameterParamToJSON)),
    };
}

